import type { ReactNode } from 'react'

type PrimaryButtonProps = {
  testLocator?: string
  onClick: () => void
  label: string
  children?: ReactNode
  primaryButtonClassName?: string
  isDisabled?: boolean
  isActive?: boolean
  'aria-label'?: string
  /** Hint announced after name + role (maps to accessibilityHint / TalkBack usage hint). */
  'aria-description'?: string
}

export const PrimaryButton = ({
  onClick,
  label,
  children,
  primaryButtonClassName,
  isDisabled,
  isActive,
  testLocator,
  'aria-label': ariaLabel,
  'aria-description': ariaDescription
}: PrimaryButtonProps) => {
  return (
    <button
      test-locator={testLocator}
      aria-label={ariaLabel}
      aria-description={ariaDescription}
      className={`bg-[#232323] ${isActive ? 'bg-[#3D3D3D]' : ''} text-white rounded-[12px] h-[48px] w-full 
        focus:outline-none hover:border-none font-[500] text-[14px] text-center disabled:bg-[#D1D6D6] pb-3 ${primaryButtonClassName ?? ''}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children ?? label}
    </button>
  )
}
